import Amount from "../helpers/amount";
import Money from "../helpers/money";

window.global_layer = window.global_layer || [];

export class GtmDataLayer {
    static addToCart(product, step, value) {
        window.global_layer.push({
            'event': 'add_to_cart',
            'ecommerce': {
                'currency': 'EUR',
                'add': {
                    'items': [{
                        'item_name': product.name.toLowerCase(),
                        'item_id': product.id.toLowerCase(),
                        'price': parseFloat(product.price).toFixed(2),
                        'item_brand': 'exact',
                        'item_category': product.productCode.toLowerCase(),
                        'item_variant': product.packageCode.toLowerCase(),
                        'quantity': product.quantity,
                    }],
                },
            },
            'value': value,
            'funnel_step_name': step.name.toLowerCase(),
            'funnel_step_id': step.id.toLowerCase(),
            'product_name': product.productCode.toLowerCase(),
            'product_version': product.packageCode.toLowerCase(),
        });
    }

    static removeFromCart(product, step, value) {
        window.global_layer.push({
            'event': 'remove_from_cart',
            'ecommerce': {
                'currency': 'EUR',
                'remove': {
                    'items': [{
                        'item_name': product.name.toLowerCase(),
                        'item_id': product.id.toLowerCase(),
                        'price': parseFloat(product.price).toFixed(2),
                        'item_brand': 'exact',
                        'item_category': product.productCode.toLowerCase(),
                        'item_variant': product.packageCode.toLowerCase(),
                        'quantity': product.quantity,
                    }],
                },
            },
            'value': value,
            'funnel_step_name': step.name.toLowerCase(),
            'funnel_step_id': step.id.toLowerCase(),
            'product_name': product.productCode.toLowerCase(),
            'product_version': product.packageCode.toLowerCase(),
        });
    }

    static checkout(product, users, modules, extras, step, formFields) {
        const productJSON = {
            'item_name': product.name.toLowerCase(),
            'item_id': product.packageId,
            'price': parseFloat(product.amount).toFixed(2),
            'item_brand': 'exact',
            'item_category': product.productCode.toLowerCase(),
            'item_variant': product.packageCode.toLowerCase(),
            'quantity': 1,
        };

        const usersJSON = users.filter(user => user.numberOfUsers > 1 && user.numberOfUsers > user.numberOfFreeUsers).map(user => ({
            'item_name': user.name.toLowerCase(),
            'item_id': user.id.toLowerCase(),
            'price': parseFloat(user.amountPerUser).toFixed(2),
            'item_brand': 'exact',
            'item_category': product.productCode.toLowerCase(),
            'item_variant': product.packageCode.toLowerCase(),
            'quantity': user.numberOfUsers - user.numberOfFreeUsers,
        }));

        const modulesJSON = modules.filter(module => module.active).map(module => ({
            'item_name': module.name.toLowerCase(),
            'item_id': module.id.toLowerCase(),
            'price': parseFloat(module.bundlePrice).toFixed(2),
            'item_brand': 'exact',
            'item_category': product.productCode.toLowerCase(),
            'item_variant': product.packageCode.toLowerCase(),
            'quantity': module.numberOfItems,
        }));

        const extrasJSON = extras.filter(extra => extra.active).map(extra => ({
            'item_name': extra.name.toLowerCase(),
            'item_id': extra.id.toLowerCase(),
            'price': parseFloat(extra.amount).toFixed(2),
            'item_brand': 'exact',
            'item_category': product.productCode.toLowerCase(),
            'item_variant': product.packageCode.toLowerCase(),
            'quantity': 1,
        }));
        const products = [productJSON,...usersJSON, ...modulesJSON, ...extrasJSON];
        const paymentTypeField = formFields.find(field => field.id === 'paymentType');
        const option = (step.id === 'step_7') && paymentTypeField ? paymentTypeField.value.substring(paymentTypeField.value.indexOf('-') + 1, paymentTypeField.value.length) : '';

        window.global_layer.push({
            'event': 'begin_checkout',
            'ecommerce': {
                'actionField': {
                    'step': step.id.substring(step.id.indexOf('_') + 1, step.id.length),
                    'option': option,
                },
                'currency': 'EUR',
                'checkout': {
                    'products': products,
                },
            },
            'funnel_step_name': step.name.toLowerCase(),
            'funnel_step_id': step.id.toLowerCase(),
            'product_name': product.productCode.toLowerCase(),
            'product_version': product.packageCode.toLowerCase()
        });
    }

    static purchase(state, datalayer) {
        const revenue = Amount.calculateTotalAmount(state);
        const tax = Money.calculateTaxAmount(revenue, 21);

        // Ensure we have a unique transaction id.
        let transactionId = '';
        while (transactionId.length < 40) {
            transactionId += Math.floor(Math.random() * 10);
        }

        const actionField = {
            'transaction_id': transactionId,
            'revenue': (revenue + tax).toFixed(2),
            'tax': tax.toFixed(2),
        }

        const productJSON = {
            'item_name': state.product.name.toLowerCase(),
            'item_id': state.product.packageId,
            'price': parseFloat(state.product.amount).toFixed(2),
            'item_brand': 'exact',
            'item_category': state.product.productCode.toLowerCase(),
            'item_variant': state.product.packageCode.toLowerCase(),
            'quantity': 1,
        };

        const usersJSON = state.users.filter(user => user.numberOfUsers > 1 && user.numberOfUsers > user.numberOfFreeUsers).map(user => ({
            'item_name': user.name.toLowerCase(),
            'item_id': user.id.toLowerCase(),
            'price': parseFloat(user.amountPerUser).toFixed(2),
            'item_brand': 'exact',
            'item_category': state.product.productCode.toLowerCase(),
            'item_variant': state.product.packageCode.toLowerCase(),
            'quantity': user.numberOfUsers - user.numberOfFreeUsers,
        }));

        const modulesJSON = state.modules.filter(module => module.active).map(module => ({
            'item_name': module.name.toLowerCase(),
            'item_id': module.id.toLowerCase(),
            'price': parseFloat(module.bundlePrice).toFixed(2),
            'item_brand': 'exact',
            'item_category': state.product.productCode.toLowerCase(),
            'item_variant': state.product.packageCode.toLowerCase(),
            'quantity': module.numberOfItems,
        }));

        const extrasJSON = state.extras.filter(extra => extra.active).map(extra => ({
            'item_name': extra.name.toLowerCase(),
            'item_id': extra.id.toLowerCase(),
            'price': parseFloat(extra.amount).toFixed(2),
            'item_brand': 'exact',
            'item_category': state.product.productCode.toLowerCase(),
            'item_variant': state.product.packageCode.toLowerCase(),
            'quantity': 1,
        }));
        const products = [productJSON,...usersJSON, ...modulesJSON, ...extrasJSON];

        /* eslint-disable */
        try {
            eval(datalayer);
        } catch (e) {}
        /* eslint-enable */

        window.global_layer.push({
            'event': 'purchase',
            'ecommerce': {
                'currency': 'EUR',
                'purchase': {
                    'actionField': actionField,
                    'products': products,
                },
            },
            'product_name': state.product.productCode.toLowerCase(),
            'product_version': state.product.packageCode.toLowerCase(),
            'value': Amount.calculateTotalAmountIncludingExtras(state)
        });
    }

    static formFields(state) {
        for (const field of state.formFields) {
            let currentStep = null;
            currentStep = state.steps.find(step => step.id === field.stepId);

            const radioFieldValue = (field.value && field.value !== true && field.value.includes('radio-')) ? field.value : false;
            const fieldValue = (!radioFieldValue && field.value !== '') ? 'filled' : 'empty';
            window.global_layer.push({
                'event': 'form_Field',
                'form_id': field.id,
                'funnel_step_name': currentStep.name.toLowerCase(),
                'funnel_step_id': field.stepId.toLowerCase(),
                'product_name': state.product.productCode.toLowerCase(),
                'product_version': state.product.packageCode.toLowerCase(),
                'field_name': field.label,
                'field_value': radioFieldValue || fieldValue
            });
        }
    }

    static contactSupport(contactType, state) {
        const currentStep = state.steps.find(step => step.current === true);
        window.global_layer.push({
            'event': 'contact_support',
            'contact_type': contactType,
            'funnel_step_name': currentStep.name.toLowerCase(),
            'funnel_step_id': currentStep.id.toLowerCase(),
            'product_name': state.product.productCode.toLowerCase(),
            'product_version': state.product.packageCode.toLowerCase(),

        });
    }
}

export default GtmDataLayer;
